export default {
  title: '' // default page title

}